import { render, staticRenderFns } from "./layout-horizontal.md?vue&type=template&id=52f7484f&"
import script from "./layout-horizontal.md?vue&type=script&lang=js&"
export * from "./layout-horizontal.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f7484f')) {
      api.createRecord('52f7484f', component.options)
    } else {
      api.reload('52f7484f', component.options)
    }
    module.hot.accept("./layout-horizontal.md?vue&type=template&id=52f7484f&", function () {
      api.rerender('52f7484f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/legend/layout-horizontal.md"
export default component.exports